const headList= [
  {
    tmscode: '76577',
    title: '中物国际智慧供应链TMS',
    image: 'zhongwutitlelogo.png'
  },
  {
    tmscode: '77717',
    title: '亚东国际货运',
    image: 'yadong_logo.png'
  },
  {
    tmscode: '78077',
    title: '润邦达美',
    image: 'rbdm_icon.png'
  },
  {
    tmscode: '78653',
    title: '传泰智慧物流供应链管理平台',
    image: 'ctLogo_mini.png'
  },
  {
    tmscode: '78995',
    title: '大顺顺达',
    image: '78995_mini.png',
  },
  {
    tmscode: '79566',
    title: '元极泰供应链',
    image: '79566.ico',
    noIcon: true
  },
  {
    tmscode: '79932',
    title: '合丰物流',
    image: '79932_mini.jpg'
  },
  {
    tmscode: '80153',
    title: '恒瑞物流',
    image: '80153_mini.png'
  }, 
  {
    tmscode: '80780',
    title: '众力物流',
    image: '80780_mini.png'
  },
  {
    tmscode: '81573',
    title: '雅利安供应链',
    image: '81573_mini.png'
  },
  {
    tmscode: '80979',
    title: '广州长久物流',
    image: '80979_mini.png'
  },
  {
    tmscode: '86407',
    title: '贵阳荟湘物流',
    image: 'hx86407_icon.png'
  },
  {
    tmscode: '86410',
    title: '石金供应链',
    noIcon: true
  },
  {
    tmscode: '86583',
    title: '济南鸿皓物流',
    image: '86583_mini.png'
  },
  {
    tmscode: '88987',
    title: '长远众邦达',
    noIcon: true
  },
  {
    tmscode: '86250',
    title: '上海普朗物流',
    image: 'shpl_logo.png'
  },
  {
    tmscode: '90369',
    title: '天圆地方物流',
    image: '90369_ico.ico'
  },
  {
    tmscode: '87218',
    title: '海成物流',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-hcwl_logo.png'
  },
  {
    tmscode: '96325',
    title: '云梦快运',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/6ab62965-4983-4efd-816a-588d4e25face.jpg'
  },
  {
    tmscode: '96822',
    title: '广州申扬物流',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/2c7f8710-4072-4cf5-85f2-12a763dafdcb.jpg'
  },
  {
    tmscode: '92032',
    title: '义乌市亿冠物流有限公司',
    image: 'favicon92032.png'
  },
  {
    tmscode: '92890',
    title: '上海晓骏供应链',
    image: 'LOGO92890.png'
  },
  {
    tmscode: '81994',
    title: '振胜物流',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/3c88660b-6a8c-4421-921e-ac221908c455.jpg'
  },
  {
    tmscode: '97899',
    title: '创峰物流',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/84e5b38b-ee03-464d-bdd7-dc93f86d587a.jpg'
  },
  {
    tmscode: '97093',
    title: '上海威捷国际',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/c5d1457e-3c67-4c6d-9433-a2480331ca4a.jpg'
  },
  {
    tmscode: '97276',
    title: '天津远东物流',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/27e8644d-e77e-4b7e-9f56-9ec078418a84.png'
  },
  {
    tmscode: '97379',
    title: '潞霏物流',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/4d94367a-a0e6-45d4-ad20-5778108ac2c0.jpg'
  },
  {
    tmscode: '86578',
    title: '盛之阳物流',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/afba636d-5725-4243-b4fa-3b0829b1f9a9.jpg'
  },
  {
    tmscode: '98002',
    title: '中物国际',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/f55e19fa-ed7a-4364-a8e9-a4d2f0727226.jpg'
  },
  {
    tmscode: '98951',
    title: '大随通物流园',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/f75a2142-346c-4e0d-99c3-723e0164f6b4.png'
  },
  {
    tmscode: '71279',
    title: '上海华汇供应链',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/ce2b207c-8612-424a-9686-7fe2d6bf8f18.png'
  },
  {
    tmscode: '60682',
    title: '上海佳络物流',
    image: 'https://files2.lqfast.com:28030/Files/Lq16888/20260116/e2e1683b-e80b-40bf-8719-dc8b49b0b82d.jpg'
  },
  {
    tmscode: '61862',
    title: '报业传媒发行物流',
    image: 'https://imagecdn.ymm56.com/ymmfile/static/resource/9a8e150f-7ffc-49fc-a056-e570579d0e24.png'
  },
]
export default headList